// slice 02.1 · paso b.6e — capa SVG de conexiones entre nodos del canvas de roadmap
// (`ComponentTaskFlow.jsx`): las líneas confirmadas (`edges`) más la línea punteada de preview
// mientras se arrastra una conexión nueva (`drawingEdge`). Presentacional puro.

export default function FlowEdgesLayer({ edges, nodes, drawingEdge, canvasWidth, canvasHeight }) {
    return (
        <svg
            style={{ position: 'absolute', top: 0, left: 0, width: canvasWidth, height: canvasHeight, pointerEvents: 'none', zIndex: 1 }}
        >
            {edges.map(edge => {
                const sNode = nodes.find(n => n.id === edge.sourceId);
                const tNode = nodes.find(n => n.id === edge.targetId);
                if (!sNode || !tNode) return null;

                const sx = sNode.category === 'etapa' ? sNode.x + (sNode.w || 260) : sNode.x + 130;
                const sy = sNode.category === 'etapa' ? sNode.y + (sNode.h || 180) / 2 : sNode.y + 20;
                const tx = tNode.x;
                const ty = tNode.category === 'etapa' ? tNode.y + (tNode.h || 180) / 2 : tNode.y + 20;

                return (
                    <path
                        key={edge.id}
                        d={`M ${sx},${sy} C ${sx + 80},${sy} ${tx - 80},${ty} ${tx},${ty}`}
                        fill="none"
                        stroke="rgba(255,255,255,0.4)"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                );
            })}
            {drawingEdge && (
                <path
                    d={`M ${drawingEdge.startX || 0},${drawingEdge.startY || 0} C ${(drawingEdge.startX || 0) + 80},${drawingEdge.startY || 0} ${(drawingEdge.endX || 0) - 80},${drawingEdge.endY || 0} ${drawingEdge.endX || 0},${drawingEdge.endY || 0}`}
                    fill="none"
                    stroke="rgba(255,255,255,0.8)"
                    strokeWidth="2"
                    strokeDasharray="5,5"
                    strokeLinecap="round"
                />
            )}
        </svg>
    );
}
